/* src/app/shared/components/mce-editor/mce-editor.component.scss */
.mce-editor-wrapper {
  display: flex;
  flex-direction: column;
  max-height: 70vh;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.mce-editor-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1px;
  padding: 4px 6px;
  background: #fafafa;
  border-bottom: 1px solid #e0e0e0;
}
.mce-editor-toolbar button:not(.mce-more-item) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: #444;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}
.mce-editor-toolbar button:not(.mce-more-item) mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.mce-editor-toolbar button:not(.mce-more-item):hover {
  background: #eeeeee;
  color: #111;
}
.mce-editor-toolbar button:not(.mce-more-item).active {
  background: #e3edf7;
  color: #1565c0;
}
.mce-format-select {
  padding: 3px 6px;
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  background: #fff;
  font-size: 13px;
  cursor: pointer;
  height: 30px;
}
.mce-format-select:hover {
  border-color: #9e9e9e;
}
.mce-format-select:focus {
  outline: none;
  border-color: #4a90d9;
}
.mce-editor-separator {
  width: 1px;
  height: 22px;
  background: #e0e0e0;
  margin: 0 4px;
  flex-shrink: 0;
}
.mce-editor-content {
  padding: 12px 16px;
  min-height: 200px;
  flex: 1;
  overflow-y: auto;
  overflow-x: auto;
  outline: none;
}
.mce-editor-content img {
  max-width: 100%;
  cursor: default;
}
.mce-editor-content img.ProseMirror-selectednode {
  outline: 2px solid #4a90d9;
}
.mce-editor-content:focus {
  outline: none;
}
.mce-editor-error {
  padding: 8px 12px;
  color: #c62828;
  background: #ffebee;
  border-bottom: 1px solid #ffcdd2;
  font-size: 12px;
}
.mce-table-picker-wrap {
  position: relative;
}
.mce-table-picker-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 1000;
}
.mce-more-wrap {
  position: relative;
  margin-left: auto;
}
.mce-more-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 1000;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  padding: 6px 0;
}
.mce-more-section-label {
  padding: 4px 14px 2px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #9e9e9e;
}
.mce-more-divider {
  height: 1px;
  background: #eeeeee;
  margin: 4px 0;
}
.mce-more-item-wrap {
  position: relative;
}
.mce-more-table-picker {
  padding: 0 14px 6px;
}
button.mce-more-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 7px 14px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 13px;
  color: #333;
  text-align: left;
  border-radius: 0;
  height: auto;
  width: 100%;
}
button.mce-more-item mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  color: #555;
  flex-shrink: 0;
}
button.mce-more-item .mce-more-item-label {
  flex: 1;
}
button.mce-more-item .mce-more-item-glyph {
  flex: 0 0 auto;
  min-width: 18px;
  color: #555;
}
button.mce-more-item .mce-more-chevron {
  color: #bdbdbd;
}
button.mce-more-item:hover:not([disabled]) {
  background: #f5f5f5;
}
button.mce-more-item[disabled] {
  opacity: 0.4;
  cursor: default;
}
.mce-table-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1px;
  padding: 3px 6px;
  background: #f0f4ff;
  border-bottom: 1px solid #c5cae9;
}
.mce-table-toolbar button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: #444;
}
.mce-table-toolbar button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}
.mce-table-toolbar button:hover {
  background: #dde4ff;
}
.mce-table-toolbar button.mce-btn-danger:hover {
  background: #ffebee;
  color: #c62828;
}
.mce-table-toolbar .mce-table-toolbar-label {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  color: #5c6bc0;
  margin: 0 2px;
  flex-shrink: 0;
}
:host ::ng-deep .ProseMirror {
  min-height: 200px;
  outline: none;
}
:host ::ng-deep .ProseMirror p {
  margin: 0.5em 0;
}
:host ::ng-deep .ProseMirror h1 {
  font-size: 2em;
  font-weight: 700;
  margin: 0.75em 0 0.25em;
}
:host ::ng-deep .ProseMirror h2 {
  font-size: 1.5em;
  font-weight: 600;
  margin: 0.75em 0 0.25em;
}
:host ::ng-deep .ProseMirror h3 {
  font-size: 1.25em;
  font-weight: 600;
  margin: 0.75em 0 0.25em;
}
:host ::ng-deep .ProseMirror blockquote {
  border-left: 3px solid #e0e0e0;
  margin-left: 0;
  padding-left: 12px;
  color: #616161;
}
:host ::ng-deep .ProseMirror ul {
  list-style-type: disc;
  padding-left: 1.5em;
  margin: 0.5em 0;
}
:host ::ng-deep .ProseMirror ol {
  list-style-type: decimal;
  padding-left: 1.5em;
  margin: 0.5em 0;
}
:host ::ng-deep .ProseMirror li {
  margin: 0.25em 0;
}
:host ::ng-deep .ProseMirror code {
  background: #f5f5f5;
  padding: 2px 4px;
  border-radius: 3px;
}
:host ::ng-deep .ProseMirror pre {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  overflow-x: auto;
}
:host ::ng-deep .ProseMirror a {
  color: #1565c0;
  text-decoration: underline;
  text-underline-offset: 2px;
}
:host ::ng-deep .ProseMirror img {
  max-width: 100%;
  cursor: default;
}
:host ::ng-deep .ProseMirror table {
  border-collapse: collapse;
  width: 100%;
  margin: 0.75em 0;
  table-layout: fixed;
  overflow: hidden;
}
:host ::ng-deep .ProseMirror table td,
:host ::ng-deep .ProseMirror table th {
  border: 1px solid #bdbdbd;
  padding: 6px 10px;
  min-width: 40px;
  vertical-align: top;
  position: relative;
  box-sizing: border-box;
}
:host ::ng-deep .ProseMirror table td.selectedCell::after,
:host ::ng-deep .ProseMirror table th.selectedCell::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(21, 101, 192, 0.12);
  pointer-events: none;
}
:host ::ng-deep .ProseMirror table th {
  background: #e8eaf6;
  font-weight: 600;
  text-align: left;
}
:host ::ng-deep .ProseMirror table .column-resize-handle {
  position: absolute;
  right: -2px;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #4a90d9;
  cursor: col-resize;
  pointer-events: auto;
}
:host ::ng-deep .ProseMirror .tableWrapper {
  overflow-x: auto;
}
:host ::ng-deep .ProseMirror .resize-cursor {
  cursor: col-resize;
}
:host ::ng-deep .ProseMirror .mce-math-node {
  display: inline-block;
  cursor: pointer;
  border-radius: 3px;
  padding: 0 2px;
  transition: background 0.1s;
}
:host ::ng-deep .ProseMirror .mce-math-node:hover {
  background: #e3edf7;
}
:host ::ng-deep .ProseMirror .mce-math-node.ProseMirror-selectednode {
  outline: 2px solid #4a90d9;
  background: #e3edf7;
}
:host {
  display: block;
  width: 100%;
  min-width: 0;
}
.mce-editor-wrapper {
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-width: 100%;
}
.mce-editor-content {
  overflow-y: auto;
  overflow-x: auto;
}
:host ::ng-deep .ProseMirror {
  min-width: 0;
  overflow-wrap: anywhere;
}
/*# sourceMappingURL=mce-editor.component-JZSKQ323.css.map */
